// _helpers
import { isIE } from '../../utils/browsers';
import { SLIDES_SELECTOR, MOBILE_SCROLL, MOBILE_ELEMS, DESKTOP_ELEMS } from './Timeline._constants';
import { SCREEN_WIDTH } from '../../utils/media';
// polyfill for element.scrollIntoView
if (typeof window !== 'undefined' && !!document && !('scrollBehavior' in document.documentElement.style)) {
    import('scroll-behavior-polyfill');
}
// TODO
// @todo update types
// @todo use refs / ref forwarding if applicable
// year(s) calculations
export const calcDecadeFromYear = (year) => {
    return Math.floor(year / 10) * 10 || year;
};
export const getYearsFlat = (years) => {
    let allYears = [];
    if (years && years.length) {
        for (let i = 0; i < years.length; ++i) {
            const yearsArr = [];
            if (years[i] && years[i]['items'] && years[i]['items'].length > 0) {
                for (let j = 0; j < years[i]['items'].length; ++j) {
                    yearsArr.push({ year: years[i]['items'][j]['year'], id: years[i]['items'][j]['id'] });
                }
            }
            allYears = allYears.concat(yearsArr);
        }
    }
    return allYears;
};
export const getYearPrevOrNext = (years, current, add = 1) => {
    const idx = years.findIndex((fi) => fi.id === current.id);
    if (idx >= 0) {
        return years[idx + add] || 0;
    }
    return 0;
};
export const getYearDetailsByIndex = (years, idx) => {
    return years[idx] || { year: -1, id: '' };
};
export const getYearsCount = (years) => {
    let totalYears = 0;
    for (let i = 0; i < years.length; ++i) {
        totalYears += years[i].items.length || 0;
    }
    return totalYears;
};
export const setTimelineYearsObject = (fieldsData) => {
    /*
          Returns data structure in format:
          [{
              decade: <year>
              items:  <array of objects, 1 for each year, including multiples of same year>
           }
           ...
          ]
       */
    let itemsArr = [];
    for (let i = 0; i < fieldsData.length; ++i) {
        const decadeLevelObj = Object.assign({}, fieldsData[i]['fields']);
        decadeLevelObj['decade'] = parseInt(decadeLevelObj['decade']['value'], 0);
        const yearArr = [];
        const decadeLevelItems = decadeLevelObj.items;
        if (decadeLevelItems && decadeLevelItems.length > 0) {
            for (let j = 0; j < decadeLevelItems.length; ++j) {
                const yearObj = {
                    year: decadeLevelItems[j]['fields']['year']['value'],
                };
                const yearLevelItems = decadeLevelItems[j]['fields']['items'];
                if (!yearLevelItems) {
                    return [];
                }
                for (let k = 0; k < yearLevelItems.length; ++k) {
                    const yearObjItem = Object.assign(Object.assign({}, yearObj), yearLevelItems[k]);
                    yearArr.push(yearObjItem);
                }
                decadeLevelObj['items'] = yearArr;
            }
        }
        itemsArr.push(decadeLevelObj);
    }
    return itemsArr;
};
// scrolling, slides, etc.
export const getTimelineSlides = () => {
    let slides;
    if (!slides) {
        slides = getElements(SLIDES_SELECTOR);
    }
    return slides;
};
export const getMinDecade = (years) => {
    const decades = [];
    for (let i = 0; i < years.length; ++i) {
        decades.push(years[i]['decade']);
    }
    return Math.min(...decades);
};
export const getFirstSlideYearAndId = (years) => {
    if (!years || !years.length) {
        return;
    }
    const decade = getMinDecade(years);
    const idx = years.findIndex((fi) => fi.decade === decade);
    const yearsArr = years[idx].items;
    let year = 0, yearReturn = [];
    for (let i = 0; i < yearsArr.length; ++i) {
        const yearCheck = yearsArr[i].year;
        if (i === 0 || (yearCheck !== 0 && yearCheck < year)) {
            year = yearCheck;
            yearReturn.push(yearsArr[i]);
        }
    }
    // unknown if slides will come in order, assume first
    return yearReturn[0];
};
export const getSlidesVisibleYear = (timelineSlides, contentHeight, isUp = false) => {
    const TOP_TWEAK = -50;
    // const BOTTOM_TWEAK = 50;
    const attr = isIE() ? 2 : 1;
    let yearHL = { year: 0, id: '' };
    for (let i = 0; i < timelineSlides.length; ++i) {
        const slide = timelineSlides[i];
        const top = slide.getBoundingClientRect().top;
        const bottom = slide.getBoundingClientRect().bottom;
        if (!isUp && top >= TOP_TWEAK && top <= contentHeight) {
            yearHL = { year: parseInt(slide.attributes[attr].value, 0), id: slide.attributes[attr + 1].value };
            break;
        }
        else if (isUp && bottom >= TOP_TWEAK && bottom <= contentHeight) {
            yearHL = {
                year: parseInt(slide.attributes[attr].value, 0),
                id: slide.attributes[attr + 1].value,
            };
            break;
        }
    }
    return yearHL;
};
export const scrollSlideIntoView = (year, id) => {
    const slide = getElements(`section[data-year="${year}"][data-id="${id}"]`, true);
    if (slide) {
        slide.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return true;
    }
};
export const getElements = (elem, isFirst = false) => {
    if (typeof window === 'undefined') {
        return null;
    }
    const elems = document.querySelectorAll(elem) || null;
    if (!elems) {
        return elems;
    }
    return isFirst ? elems[0] : elems;
};
export const setSlideFocus = (identifier, contentWidth = 0) => {
    if (contentWidth && useMobile(contentWidth, SCREEN_WIDTH.MOBILE)) {
        return;
    }
    const slide = getElements(`section[data-id="${identifier}"]`, true);
    if (slide) {
        const tabIdxs = slide.querySelectorAll('[tabindex="0"]');
        if (tabIdxs.length) {
            const tabIdx = tabIdxs[0];
            if (tabIdx) {
                console.log(tabIdx);
                tabIdx.focus();
            }
        }
    }
};
export const setYearFocus = (identifier) => {
    const yearSpan = getElements(`div[data-id="${identifier}"] span`, true);
    if (!yearSpan) {
        return;
    }
    yearSpan.focus();
};
export const setDecadeOnEscape = (cls = DESKTOP_ELEMS.OPEN) => {
    const decade = getElements(cls, true);
    if (decade) {
        decade.focus();
    }
};
export const getSlideTabIndices = (identifier) => {
    const slide = getElements(`section[data-id="${identifier}"] [tabindex="0"]`);
    if (slide && slide.length) {
        return slide.length;
    }
    return 0;
};
// mobile specific
export const getElementYearSize = (elem, noYears = MOBILE_SCROLL.VISIBLE_YRS) => {
    const elemWidth = elem.getBoundingClientRect().width;
    return Math.round((elemWidth / noYears) * 10) / 10 || 0;
};
export const getElementMiddle = (elem) => {
    const elemWidth = elem.getBoundingClientRect().width;
    return elemWidth / 2 || 0;
};
// apply classes to two items before / after highlight to apply wheel effect
export const removeDesignateClasses = (elems, classPrefix) => {
    for (let i = 0; i < elems.length; ++i) {
        const classes = elems[i].className.split(' ').filter(function (cls) {
            return cls.lastIndexOf(classPrefix, 0) !== 0;
        });
        elems[i].className = classes.join(' ').trim();
    }
};
export const designateAddClass = (elem, cls) => {
    const clsArr = elem.className.split(' ');
    if (clsArr.indexOf(cls) === -1) {
        elem.className += ' ' + cls;
    }
};
export const designateAddHighlightYearClasses = (elem, classPrefix) => {
    // apply classes to sibling elements in mobile
    // need to scroll to middle, have filler elements also
    // order of classes: left 2 | left 1 | highlight | right 1 | right 2
    if (elem && elem.previousSibling) {
        const left1 = elem.previousSibling;
        if (left1) {
            designateAddClass(left1, classPrefix + 'left1');
            if (left1.previousSibling) {
                const left2 = left1.previousSibling;
                if (left2) {
                    designateAddClass(left2, classPrefix + 'left2');
                }
            }
        }
    }
    if (elem && elem.nextSibling) {
        const right1 = elem.nextSibling;
        if (right1) {
            designateAddClass(right1, classPrefix + 'right1');
            if (right1.nextSibling) {
                const right2 = right1.nextSibling;
                if (right2) {
                    designateAddClass(right2, classPrefix + 'right2');
                }
            }
        }
    }
};
export const setHighlightMobileCenter = (elemParent, elem, highlightElem = MOBILE_ELEMS.HIGHLIGHT, distanceMin = MOBILE_SCROLL.DISTANCE_MIN) => {
    const containerParentMiddle = getElementMiddle(elemParent);
    const highlight = getElements(highlightElem, true);
    const hightlightDims = highlight.getBoundingClientRect();
    const highlightWidth = hightlightDims.width;
    const leftParentPositon = containerParentMiddle - highlightWidth / 2;
    let travel = 0;
    const highlightElementLeftIsHigher = hightlightDims.left > leftParentPositon;
    if (highlightElementLeftIsHigher) {
        travel = hightlightDims.left - leftParentPositon;
    }
    else {
        travel = leftParentPositon - hightlightDims.left;
    }
    if (Math.abs(travel) > distanceMin) {
        sideStyleLeftAnimation(elem, highlightElementLeftIsHigher, travel, true);
    }
};
function sideStyleLeftAnimation(elem, elemLeftLarger, distance, useStyleLeft = true, speed = 1, step = 10) {
    if (typeof window === 'undefined') {
        return;
    }
    var scrollAmount = 0;
    var slideTimer = setInterval(function () {
        if (useStyleLeft) {
            const currentLeft = parseInt((elem.style.left || 0) + '', 10);
            elem.style.left = `${currentLeft + (elemLeftLarger ? -1 * step : step)}px`;
        }
        else {
            const currentTransformY = getValueFromString(elem.style.transform || '');
            elem.style.transform = `translate(${currentTransformY + (elemLeftLarger ? -1 * step : step)}px)`;
        }
        scrollAmount += step;
        if (scrollAmount >= distance) {
            clearInterval(slideTimer);
        }
    }, speed);
}
// @todo temp. fix as highlight class
export const setHighlightClassMod = (yearData, highlightCls = MOBILE_ELEMS.HIGHLIGHT) => {
    const cls = highlightCls.replace('.', '');
    const highlight = getElements(highlightCls, true);
    if (highlight) {
        highlight.classList.remove(cls);
    }
    const yearSingleElem = getElements(`div[data-year="${yearData.year}"][data-id="${yearData.id}"]`, true);
    if (yearSingleElem.className.indexOf(cls) === -1) {
        yearSingleElem.className += ` ${cls}`;
    }
    return yearSingleElem;
};
export const setHighlightForMobile = (contentWidth, parent = MOBILE_ELEMS.CONT_PARENT, container = MOBILE_ELEMS.CONTAINER, years = MOBILE_ELEMS.YEARS, prefix = MOBILE_ELEMS.HL_PREFIX, highlightCls = MOBILE_ELEMS.HIGHLIGHT) => {
    if (contentWidth && !useMobile(contentWidth, SCREEN_WIDTH.MOBILE)) {
        return;
    }
    const elems = getElements(years);
    if (elems.length === 0) {
        return;
    }
    const elem = getElements(highlightCls, true);
    const prnt = elem.parentNode;
    removeDesignateClasses(elems, prefix);
    designateAddHighlightYearClasses(prnt, prefix);
    setHighlightMobileCenter(getElements(parent, true), getElements(container, true));
};
export const setHighlightClassesOnInit = (siblingClass = MOBILE_ELEMS.YEARS, prefix = MOBILE_ELEMS.HL_PREFIX) => {
    const elems = getElements(siblingClass);
    // @ts-ignore
    const elem = elems[2];
    if (elem) {
        designateAddHighlightYearClasses(elem, prefix);
    }
};
export const getHighlightMobileCenter = (elemParent, yearWidth) => {
    const TWEAK = 1;
    const containerParentMiddle = getElementMiddle(elemParent);
    const leftPosition = containerParentMiddle - yearWidth / 2 + TWEAK;
    return leftPosition;
};
// screen, keyboard, etc.
export const useMobile = (setWidth, compareWidth, useWindow = true) => {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
        return false;
    }
    if (useWindow && typeof document !== 'undefined') {
        return document.body.clientWidth <= compareWidth;
    }
    else if (useWindow) {
        return window.innerWidth <= compareWidth;
    }
    return setWidth ? setWidth <= compareWidth : false;
};
export const detectEnter = (evt) => {
    const keycode = evt.keyCode ? evt.keyCode : evt.which;
    return keycode === 13;
};
export const detectEscape = (evt) => {
    const keycode = evt.keyCode ? evt.keyCode : evt.which;
    return keycode === 27;
};
export const getLangFromBrowser = () => {
    if (typeof window === 'undefined') {
        return '';
    }
    return (navigator.languages && navigator.languages[0]) || navigator.language || 'en';
};
export const getValueFromString = (val) => {
    if (val.length) {
        let num = Number(val.replace(/[^\-?\.?\d*]/g, ''));
        if (num === NaN) {
            num = 0;
        }
        return num;
    }
    return 0;
};
export const getClientHeight = () => {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
        return 0;
    }
    return document.body.clientHeight || 0;
};
// only used in mobile
// findIndex does not work for IE browser
// if this function needs to be used anywhere else that isnt mpbile specific, may need to refactor findIndex as it is not supported by IE
export const getIndexByYearDetails = (years, { id: currentId }) => {
    return years.findIndex((year) => year.id === currentId);
};
